import { createAction } from '@reduxjs/toolkit'

/** Команды фичи фото — plain actions; rid в каждой (D-064). */
export const photoMainRequested = createAction<{
  resourceId: string
  refKey: string
  fileKey: string
  expectedConfigurationVersion: string
}>('onec/photos/mainRequested')

export const photoUploadRequested = createAction<{
  resourceId: string
  refKey: string
  fileToken: string
  fileName: string
  expectedConfigurationVersion: string
}>('onec/photos/uploadRequested')

/** Та же команда тем же ключом — проверка неизвестного исхода. */
export const photoOperationResendRequested = createAction<{ key: string }>('onec/photos/resendRequested')

/** Отмена идущей отправки снимка (до конца передачи): запрос прерывается, снимок остаётся для повторной отправки. */
export const photoOperationCancelRequested = createAction<{ key: string }>('onec/photos/cancelRequested')

export const photosReloadRequested = createAction<{ resourceId: string; refKey: string }>('onec/photos/reloadRequested')
